import { useState, useEffect, useCallback } from 'react'
import { gql, useLazyQuery } from '@apollo/client'
import { Metadata, ResultsList, SearchGraphql, WhereGraphql } from 'src/admin/core/models'
import _ from 'lodash'
import { AgencyWeeklySales } from '../../weeklyBalance/models/AgencyWeeklySales'

const GET_AGENCY_WEEKLY_SALES = gql`
  query AgencyTicketTransactionsSummary(
    $product: ProductEnum!
    $currency: CurrencyType!
    $from: DateTime
    $to: DateTime
    $where: TicketTransactionsSummaryFilterInput
    $provider: String!
    $enterpriseId: String!
  ) {
    agencyTicketTransactionsSummary(
      product: $product
      currency: $currency
      from: $from
      to: $to
      where: $where
      provider: $provider
      enterpriseId: $enterpriseId
      order: { amount: DESC }
    ) {
      amount
      commission
      surcharge
      key {
        id
        category
        date
        transactionType
        currency
        agency {
          name
          products {
            code
          }
        }
      }
    }
  }
`

interface Data {
  agencyTicketTransactionsSummary: AgencyWeeklySales[]
}

export const useAgencyBalances = () => {
  const [getResults, { loading, error, data }] = useLazyQuery<Data>(GET_AGENCY_WEEKLY_SALES, {
    fetchPolicy: 'network-only',
  })

  const [results, setResults] = useState<ResultsList<AgencyWeeklySales, Metadata>>({
    results: [],
    metadata: {},
  })

  const getAgencyBalances = useCallback(
    ({
      product,
      currency,
      from,
      to,
      where,
      provider,
      enterpriseId,
    }: {
      product: string
      currency: string
      from: string
      to: string
      where?: WhereGraphql | WhereGraphql[]
      provider?: string
      enterpriseId?: string
    }) => {
      getResults({
        variables: {
          where: where ? { or: where } : undefined,
          product,
          currency,
          to,
          from,
          provider: provider ?? '',
          enterpriseId: enterpriseId ?? '',
          order: {
            key: {
              date: 'ASC',
            },
          },
        },
      })
    },
    [getResults],
  )

  useEffect(() => {
    if (data?.agencyTicketTransactionsSummary) {
      setResults({
        results: data?.agencyTicketTransactionsSummary ? data?.agencyTicketTransactionsSummary : [],
        metadata: {
          Count: 100,
        },
      })
    }
  }, [loading])

  return {
    loading,
    error,
    results,
    getAgencyBalances,
  }
}
